module.exports = __webpack_public_path__ + "static/img/9areaB_06.9ef91b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_06.png
// module id = 1238
// module chunks = 1